import { computed } from '@angular/core';
import { signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';
import { RequestStatusEnum } from 'src/app/core/enums/request-status.enum';

export interface RequestStatusState {
  requestStatus: RequestStatusEnum;
  requestError: string | { error: { detail: string } } | null;
}

export function withRequestStatus() {
  return signalStoreFeature(
    withState<RequestStatusState>({
      requestStatus: RequestStatusEnum.Idle,
      requestError: null,
    }),
    withComputed(({ requestStatus }) => ({
      isIdle: computed(() => requestStatus() === RequestStatusEnum.Idle),
      isPending: computed(() => requestStatus() === RequestStatusEnum.Pending),
      isFulfilled: computed(() => requestStatus() === RequestStatusEnum.Fulfilled),
      isError: computed(() => requestStatus() === RequestStatusEnum.Error),
    })),
    withMethods(() => ({
      setIdle(): RequestStatusState {
        return {
          requestStatus: RequestStatusEnum.Idle,
          requestError: null,
        };
      },
      setPending(): RequestStatusState {
        return {
          requestStatus: RequestStatusEnum.Pending,
          requestError: null,
        };
      },
      setFulfilled(): RequestStatusState {
        return {
          requestStatus: RequestStatusEnum.Fulfilled,
          requestError: null,
        };
      },
      setError(error: string): RequestStatusState {
        return {
          requestStatus: RequestStatusEnum.Error,
          requestError: error,
        };
      },
    }))
  );
}
